

<template>
  <!--消息中心-->
  <OpDialog
    class="opple-light-elf-dialog"
    :class="{ 'step-2': step === 2 }"
    :visible="visible"
    :is-show-btn="false"
    @onClose="onClose"
  >
    <div
      v-if="step === 1"
      class="opple-light-elf"
    >
      <div class="opple-light-elf-lt">
        <div class="opple-light-elf_title">
          {{ $t('ifttt.needOneClickConfiguration') }}
        </div>
        <img
          :src="$img('elfNotice1')"
        >
        <div
          class="opple-light-elf_desc"
        >
          {{ $t('ifttt.elfInfo') }}
        </div>
      </div>
      <div class="opple-light -elf-gt">
        <div class="opple-light-elf_object">
          <p>{{ $t('ifttt.controlObject') }}</p>
          <p>{{ device.AreaName }}</p>
        </div>
        <div class="opple-light-elf_btnList">
          <div
            class="opple-light-elf_btn grey"
            @click="onClose"
          >
            {{ $t('base.skip') }}
          </div>
          <div
            class="opple-light-elf_btn blue"
            @click="onBeforeConfiguration"
          >
            {{ $t('ifttt.oneClickConfiguration') }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="step === 2"
      class="opple-light-elf"
    >
      <div class="opple-light-elf-lt">
        <div class="opple-light-elf_title" />
        <img 
          src="~@/assets/img/ifttt/elf.png" 
        >
      </div>
      <div class="opple-light -elf-gt">
        <div class="opple-light-elf_info">
          <p>{{ $t('ifttt.wakePro') }}</p>
        </div>
        <div class="opple-light-elf_btnList">
          <div
            :class="{disabled: isLoadingConfiguration }"
            class="opple-light-elf_btn blue"
            @click="onConfiguration"
          >
            {{ $t('ifttt.aWakened') }}
          </div>
        </div>
      </div>
    </div>
  </OpDialog>
</template>
<script>
import { FindIFtttListByTrigger, Create, BatchCreate } from '@/axios/IFttt.js';
import { FindTriggerAbility, GetAutoTemplateById } from '@/axios/IDevice.js';
import { getElfDefaultIfttt } from './utils';
import OpDialog from '../common/OpDialog';

export default {
  components: { 
    OpDialog
  },
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false
    // },
    device: {
      type: Object,
      default: () => null
    },
    Gpno: {
      type: Number,
      default: () => null
    },
    // onConfiguration: {
    //   type: Function,
    //   default: () => null
    // }
  },

  data() {
    return {
      visible: false,
      step: 1,
      isLoadingConfiguration: false
    }
  },

  watch: {
    device(value) {
      console.log('device !!!', value);
      if (value && value.VDeviceId) {
        this.init(value);
      }
    }
  },

  mounted(){
    if (this.device) {
      this.init(this.device);
    }
  },

  created() {
  },

  methods: {
    async init(device) {
      // 欧洲隐藏
      if (this.$store.state.isNoLimit === false) return;

      const res1 = await FindIFtttListByTrigger({
        vDeviceId: device.VDeviceId,
        ShowEntry: 1
      });

      const res2 = await FindIFtttListByTrigger({
        vDeviceId: device.VDeviceId,
        ShowEntry: 0
      });

      // 没有数据
      if (
        Array.isArray(res1.Result) && 
        Array.isArray(res2.Result) && 
        [...res1.Result, ...res2.Result].length === 0
      ) {
        this.visible = true;
      } else {
        this.visible = false;
      }
    },

    onClose() {
      this.visible = false;
    },

    onBeforeConfiguration() {
      this.step = 2;
    },

    async onConfiguration() {
      if (this.isLoadingConfiguration) return;

      try {
        this.isLoadingConfiguration = true;

        // if (this.onConfiguration) {
        //   await this.onConfiguration();

        //   this.isLoadingConfiguration = false;

        //   return;
        // }
        const iftttReqList = await getElfDefaultIfttt(this.device, {
          ActionType: 6,
          gpNo: this.device.Gpno,
          areaName: this.device.AreaName,
        });

        console.log('iftttReqList', iftttReqList);

        const createRes = await BatchCreate(iftttReqList);

        if (createRes.StatusCode === 0) {
          this.step = 1;
          this.$emit('onConfigurationSuccess');
          this.onClose();
        }

        this.isLoadingConfiguration = false;
      } catch (e) {
        console.log('req 2', e);
        this.isLoadingConfiguration = false;
      }
    },

    getSaveTemplatePackageConfig(triggerList, templates) {
      console.log('triggerList', triggerList, templates);
        const iftttCommonInfo = {
          Gpno: this.device.Gpno,
          TRI_Relation: 0,
          IsManual: false,
          IsEnable: true,
          TriggerType: 0,
          TimePeriod: {
            effectivedate: "2019-01-01,2088-12-31",
            holiday: false,
            time: "00:00",
            weeks: "Mon Tues Wed Thur Fri Sat Sun",
            zone: 0,
          },
          ShowEntry: 1
        };
        console.log('trigger 0', this.device);
        const triggerCommonInfo = {
          VDeviceId: this.device.VDeviceId,
          DeviceName: this.device.DeviceName,
          AreaName: this.device.AreaName,
          IsDel: false,
          ClassSku: this.device.ClassSku,
        };

        let iftttInfo = [];
        let recomends = [];
  
        triggerList.forEach((trigger, index) => {
          let ExecuteTaskList = {};
          let needAdd = true;
          console.log('trigger 1', trigger);

          const commercialdefaultRecommendation = trigger.UI?.commercialdefaultRecommendation || [];
          const defaultRecommendationIds = commercialdefaultRecommendation.map(
            recommendation => recommendation.templateID
          );
            console.log('trigger 2', commercialdefaultRecommendation);
            commercialdefaultRecommendation.forEach(recommend => {
            const curTemplates = templates.filter(template => commercialdefaultRecommendation.includes(template.Id));
            const curAreaList = curTemplates.reduce((pre, next) => {
              return pre.concat(next.AreaActionList || []);
            }, []);
            console.log('trigger 3', recommend);
            // 地区
            const ExecuteTaskList = {
              ActionType: 6,
              Gpno: this.device.Gpno,
              AreaName: this.device.AreaName,
              Values: curAreaList.map((action) => ({
                ControlType: action.Content.ControlType,
                Value: action.Content.Value
              }))
            };
            let ifttt = {
              ...iftttCommonInfo,
              TriggerList: [{
                ...triggerCommonInfo,
                TriggerList: [{
                  ExtraKeyId: trigger.ExtraKeyId,
                  KeyId: trigger.KeyID,
                  MsgId: trigger.MsgID,
                  OperationType: Number(recommend.OperationValue),
                  Value1: Number.isInteger(Number(recommend.Value1)) ? recommend.Value1 : Number(recommend.DefaultValue),
                  Value2: Number.isInteger(Number(recommend.Value2)) ? recommend.Value2 : null,
                }]
              }],
              ExecuteTaskList: [ExecuteTaskList],
              UITemplateId: recommend.templateID,
              UITemplateVersion: recommend.version,
              IFtttName: recommend.name,
            };

            recomends.push(ifttt);
          });
        });

        console.log('recomends recomends recomends', recomends);
        return recomends;
        // for (let trigger of triggerList) {
        //   // let bindIfttt = trigger.bindIfttts?.find(ifttt => ifttt.IFT_ID > 0);

        //   let recomends = [];
        //   for (let recommendVM of trigger.defaultRecommendation) {
        //     let ExecuteTaskList = {};
        //     let needAdd = true;

        //     // if (actionCommonInfo?.ActionType === ActionTypeEnum.Device) {
        //     //   ExecuteTaskList = {
        //     //     ...actionCommonInfo,
        //     //     ActionList: recommendVM.deviceActions
        //     //   };
        //     // }
            
        //     // if (actionCommonInfo?.ActionType === ActionTypeEnum.AreaControl) {
        //         ExecuteTaskList = {
        //           ...actionCommonInfo,
        //           Values: recommendVM.areaActions.map(({ value, type }) => ({
        //             ControlType: type,
        //             Value: value
        //           }))
        //         };
        //     // }
        //       let ifttt = {
        //         ...iftttCommonInfo,
        //         TriggerList: [{
        //           ...triggerCommonInfo,
        //           TriggerList: [{
        //             ExtraKeyId: trigger.extraKeyId,
        //             KeyId: trigger.keyID,
        //             MsgId: trigger.msgType,
        //             OperationType: recommendVM.operationValue,
        //             Value1: recommendVM.value1 ?? recommendVM.defaultValue,
        //             Value2: recommendVM.value2 ?? null,
        //           }]
        //         }],
        //         ExecuteTaskList: [ExecuteTaskList],
        //         UITemplateId: recommendVM.templateID,
        //         UITemplateVersion: recommendVM.version,
        //         IFtttName: recommendVM.name,
        //       };

        //       // if (bindIfttt && isEdit) {
        //       //     ifttt.IFtttNo = bindIfttt.IFT_ID;
        //       // }
        //       if (needAdd) {
        //           recomends.push(ifttt);
        //       }
        //   }

        //   iftttInfo = iftttInfo.concat(recomends);
        // }

        // return iftttInfo;
    }
  }
}
</script>

<style lang="scss" scoped>
.opple-light-elf-dialog {
  background: #F2F3F5;
  
  .opDialog_body {
    background: #F2F3F5;
  }

  &.step-2 {
    width: 600px;
    min-height: 206px;

    .opDialog_body {
      min-height: 206px;
      max-height: 206px;

      .opple-light-elf {
        padding: 0 28px;

        &-lt {
          img {
            width: 100px;
            height: 100px;
          }
        }

        &_btnList {
          justify-content: flex-end;
        }
      }
    }
  }
}

.opple-light-elf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F2F3F5;
  padding: 0 90px;

  &-lt {
    // padding-left: 90px;
    // margin-right: 86px;
    img {
      width: 400px;
    }
  }

  &_desc {
    width: 330px;
    font-size: 12px;
    color: #989898;
  }

  &_title {
    margin: 30px 0 40px;
    font-size: 18px;
    line-height: 26px;
    color: #000000;
  }

  &_info {
    margin: 60px 0 40px;
    font-size: 17px;
  }

  &_object {
    box-sizing: border-box;
    width: 347px;
    height: 57px;
    display: flex;
    background: #fff;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px;
    margin: 120px 0 219px;
    transform: translateX(-80px);
    padding-left: 19px;
    padding-right: 58px; 
  }

  &_btnList {
    display: flex;
    align-items: center; 
  }

  &_btn {
    min-width: 143px;
    height: 46px;    
    border-radius: 8px;
    font-size: 16px;
    line-height: 46px;
    text-align: center;
    cursor: pointer;

    &.grey {
      background: #DDDEDF;
      color: #606060;
      margin-right: 52px;
    }

    &.blue {
      background: #2145A4;
      color: #FFF;

      &.disabled {
        background: #DDDEDF;
        color: #606060;
      }
    }
  }
}
</style>
